import { makeSimpleExperiment } from '../../../../../../common/ExperimentContext/types';

export const ShowPractitionerSpecialInterestsExperiment = makeSimpleExperiment(
  'show-practitioner-special-interests',
);
